import * as moment from 'moment';
import { InvoiceItemType, InvoiceItemTypeMap } from '~/types/InvoiceItem';

export type JSONPendingInvoiceItem = {
  amount: number;
  carrier_account: string;
  currency: string;
  description: string;
  invoice_item_type: string;
  object_created: string;
  object_purpose: string;
  provider_name: string;
  servicelevel_name: string;
  tracking_number: string;
  transaction: string;
};

export default interface PendingInvoiceItem {
  amount: number;
  carrierAccount: string;
  currency: string;
  description: string;
  invoiceItemType: InvoiceItemType;
  objectCreated: moment.Moment;
  objectPurpose: string;
  providerName: string;
  servicelevelName: string;
  trackingNumber: Maybe<string>;
  transaction: Maybe<string>;
}

export function fromJSON(jsonPendingInvoiceItem: JSONPendingInvoiceItem): PendingInvoiceItem {
  return {
    amount: jsonPendingInvoiceItem.amount,
    currency: jsonPendingInvoiceItem.currency,
    carrierAccount: jsonPendingInvoiceItem.carrier_account,
    description: jsonPendingInvoiceItem.description,
    invoiceItemType: InvoiceItemTypeMap[jsonPendingInvoiceItem.invoice_item_type],
    objectCreated: moment(jsonPendingInvoiceItem.object_created),
    objectPurpose: jsonPendingInvoiceItem.object_purpose,
    providerName: jsonPendingInvoiceItem.provider_name,
    servicelevelName: jsonPendingInvoiceItem.servicelevel_name,
    trackingNumber: jsonPendingInvoiceItem.tracking_number || null,
    transaction: jsonPendingInvoiceItem.transaction || null,
  };
}
